import { render, staticRenderFns } from "./PsotAddMain.vue?vue&type=template&id=94c5b08e&scoped=true&"
import script from "./PsotAddMain.vue?vue&type=script&lang=js&"
export * from "./PsotAddMain.vue?vue&type=script&lang=js&"
import style0 from "./PsotAddMain.vue?vue&type=style&index=0&id=94c5b08e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c5b08e",
  null
  
)

export default component.exports